import { defineStore } from 'pinia';
import { useRiskProfileManager } from '@/composables/useRiskProfileManager';
import api from '@/api';

export const useSystemAdminTemplateStore = defineStore('systemAdminTemplate', () => {
    const profileManager = useRiskProfileManager({
        fetchData: api.systemAdmin.riskModelTemplates.list,
        fetchOne: api.systemAdmin.riskModelTemplates.get,
        create: api.systemAdmin.riskModelTemplates.create,
        createDraft: api.systemAdmin.riskModelTemplates.createDraft,
        promote: api.systemAdmin.riskModelTemplates.promoteDraft,
        activate: api.systemAdmin.riskModelTemplates.activate,
        deactivate: api.systemAdmin.riskModelTemplates.deactivate,
        setAsProduction: api.systemAdmin.riskModelTemplates.setReleaseAsProduction,
        discardDraft: api.systemAdmin.riskModelTemplates.discardDraft,
        setDesignated: api.systemAdmin.riskModelTemplates.setDesignatedInstance,
        delete: api.systemAdmin.riskModelTemplates.delete,
    });

    // --- Mapped Interface ---
    // This maintains the public interface of the store, so no components need to change.

    function navigateToWizard() {
        profileManager.navigateToAddProfile();
    }

    return {
        // State (mapped)
        templateGroups: profileManager.profileGroups,
        selectedTemplateGroup: profileManager.selectedProfileGroup,
        isLoading: profileManager.isLoading,
        activeView: profileManager.activeView,
        baseForWizard: profileManager.baseForWizard,
        searchQuery: profileManager.searchQuery,
        isSaving: profileManager.isSaving,
        error: profileManager.error,

        // Pagination / sort state (mapped)
        totalRecords: profileManager.totalRecords,
        first: profileManager.first,
        pageSize: profileManager.pageSize,
        sortField: profileManager.sortField,
        sortOrder: profileManager.sortOrder,

        // Getters (mapped)
        filteredTemplateGroups: profileManager.filteredProfileGroups,
        getReleases: profileManager.getReleases,
        getDraft: profileManager.getDraft,
        getCurrentInstance: profileManager.getCurrentInstance,
        getLatestRelease: profileManager.getLatestRelease,

        // Actions (mapped or direct)
        fetchData: profileManager.fetchData,
        fetchProfileGroup: profileManager.fetchProfileGroup,
        setPage: profileManager.setPage,
        setSort: profileManager.setSort,
        setSearch: profileManager.setSearch,
        setStatusFilter: profileManager.setStatusFilter,
        setIsActiveFilter: profileManager.setIsActiveFilter,
        saveNewTemplate: profileManager.saveNewProfile,
        saveNewDraftInstance: profileManager.saveNewDraftInstance,
        promoteToProduction: profileManager.promoteToProduction,
        activateRiskModel: profileManager.activateRiskModel,
        deactivateRiskModel: profileManager.deactivateRiskModel,
        setReleaseAsProduction: profileManager.setReleaseAsProduction,
        createDraftFromRelease: profileManager.createDraftFromRelease,
        discardDraft: profileManager.discardDraft,
        setDesignatedInstance: profileManager.setDesignatedInstance,
        navigateToList: profileManager.navigateToList,
        navigateToDetails: profileManager.navigateToProfileDetails,
        navigateToWizard, // Mapped function
        navigateToEditDraft: profileManager.navigateToEditDraft,
        cloneProfile: profileManager.cloneProfile,
        deleteProfile: profileManager.deleteProfile,
    };
});